export default __webpack_public_path__ + "static/media/icon-256x256.6a4cfff3.png";